export default __webpack_public_path__ + "static/media/StarttoEnd.229672ab.svg";